import { connect } from 'react-redux';
import Negotiation, { aggregationsProps } from '../../../component/templates/Negotiation';
import { Dispatch } from 'redux';
import { actions } from '@common/redux/modules/Actions';
import { SearchConditionState } from '@common/redux/reducers/SearchConditionReducer';
import { LINE_TYPE, SCREEN, STATUS_TYPE, TAB_TYPE } from '@common/Common';
import { updateAggregations } from '../NegotiationContainerCommons';
import { AgencyAppState } from '../../../redux/modules/store';
import { StoreAndAgencyInfo } from '@common/redux/reducers/StoreSelectorReducer';
import { AnnotationTooltipProps } from '@common/component/molecules/AnnotationTooltip';
import { getAnnotationMasterListFromMasterInfo } from '@common/redux/reducers/MasterInfoReducer';
import ANNOTATION_ID from '@common/redux/reducers/MasterInfoReducer/definitions/AnnotationId';

const mapStateToProps = (appState: AgencyAppState) => {
  const tooltipInfo = getAnnotationMasterListFromMasterInfo(appState.masterInfo, ANNOTATION_ID.ANTT_I_15);

  return {
    userId: appState.loginUser.crewCd,
    isLoggedIn: appState.loginUser.isLoggedIn,
    agencyCd: appState.storeSelector.selectedStores,
    reportTableRow: appState.reportTableRow,
    searchBranchNextAction: appState.searchBranchNextAction,
    searchBranchPending: appState.searchBranchPending,
    searchBranchPeriod: appState.searchBranchPeriod,
    searchBranchProb: appState.searchBranchProb,
    searchBranchResult: appState.searchBranchResult,
    searchBranchStatus: appState.searchBranchStatus,
    searchBranchCommodityCategoryContract: appState.searchBranchCommodityCategoryContract,
    storeSelector: appState.storeSelector,
    header: {
      screenId: SCREEN.PENDING_NEGOTIATION.ID,
      screenName: SCREEN.PENDING_NEGOTIATION.NAME,
      statusType: STATUS_TYPE.PENDING,
      loadingStatus: appState.loadingStatus.pendingNegotiation,
    },
    currentFilterCondition: appState.currentFilterCondition,
    filterList: appState.filterList,
    tabContent: [
      {
        tabkey: {
          title: '保留期間別',
          type: TAB_TYPE.PENDING,
          url: `${SCREEN.PENDING_NEGOTIATION.URL}/${TAB_TYPE.PENDING}`,
          lineType: LINE_TYPE.PENDING,
        },
        tableCount: appState.negotiationPending,
      },
      {
        tabkey: {
          title: '次のアクション',
          type: TAB_TYPE.ACTION,
          url: `${SCREEN.PENDING_NEGOTIATION.URL}/${TAB_TYPE.ACTION}`,
          lineType: LINE_TYPE.ACTION,
        },
        tableCount: appState.negotiationNextAction,
      },
      {
        tabkey: {
          title: '契約確率',
          type: TAB_TYPE.PROB,
          url: `${SCREEN.PENDING_NEGOTIATION.URL}/${TAB_TYPE.PROB}`,
          lineType: LINE_TYPE.PROB,
        },
        tableCount: appState.negotiationProb,
      },
    ],
    tooltipInfo: {
      content: tooltipInfo.annotationText,
      url: tooltipInfo.linkUrl,
      label: tooltipInfo.linkText,
    } as AnnotationTooltipProps,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  const lineTypes = [LINE_TYPE.PENDING, LINE_TYPE.ACTION, LINE_TYPE.PROB];
  const statusType = STATUS_TYPE.PENDING;
  return {
    updateSearchCondition: (searchCondisiton: SearchConditionState) => {
      dispatch(actions.updateSearchCondition(searchCondisiton));
    },
    aggregations: (props: aggregationsProps) => {
      updateAggregations(props, lineTypes, statusType, dispatch);
    },
    updateRefresh: (props: aggregationsProps) => {
      const refresh = () => {
        console.log('current Refresh is Pending Negotiation');
        updateAggregations(props, lineTypes, statusType, dispatch);
      };
      dispatch(actions.updateRefresh({ refresh }));
    },
    clearFilter: () => {
      dispatch(actions.clearFilter());
    },
    setToggleModal: () => {
      dispatch(actions.storeSelector.toggleModal());
    },
    setToggleStore: (store: StoreAndAgencyInfo) => {
      store && dispatch(actions.storeSelector.toggleStore(store));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Negotiation);
